<div class="pagination col-md-12" style="padding:0 30px">
        <ul  class="pagination">
            <li   class="page-item"  [ngClass]="{disabled:currentPage === 1}">
                <a   class="page-link"   (click)="setPage(1)">first</a>
            </li>
            <li  class="page-item"  [ngClass]="{disabled:currentPage === 1}">
                <a  class="page-link"   (click)="setPage(currentPage - 1)">previous</a>
            </li>
            <li  class="page-item"   *ngFor="let page of displayPager" 
              [ngClass]="{active:currentPage === page}">
                <a  class="page-link"  (click)="setPage(page)">{{page}}</a>
            </li>
            <li  class="page-item"  [ngClass]="{disabled:currentPage === totalPages}">
                <a  class="page-link"  (click)="setPage(currentPage + 1)">next</a>
            </li>
            <li  class="page-item" [ngClass]="{disabled:currentPage === totalPages}">
                <a  class="page-link"  (click)="setPage(totalPages)">last</a>
            </li>
        </ul>
    </div>

 